import React from 'react';
import { TextInput } from '../../form/TextInput';
import { NumberInput } from '../../form/NumberInput';
import { SelectInput } from '../../form/SelectInput';
import { YesNoInput } from '../../form/YesNoInput';
import { Button } from '../../components/Button';
import * as Grid from '../../components/Grid';
import { useHasMany } from './shared/useHasMany';
export const InsuranceLosses = ({ orderId, insuranceLosses, onChange, errors, }) => {
    const year = new Date().getFullYear();
    const lastFiveYears = [
        year - 5,
        year - 4,
        year - 3,
        year - 2,
        year - 1,
        year,
    ].map((v) => {
        return { value: v, name: v.toString() };
    });
    const onInsuranceLossesChange = (losses) => {
        onChange({
            insurance_losses_attributes: losses,
        });
    };
    const { onUpdate, onAdd, onRemove, showRecords, setShowRecords, buildNewRecord, } = useHasMany({
        orderId,
        keyBase: 'loss',
        records: insuranceLosses,
        onChange: onInsuranceLossesChange,
    });
    React.useEffect(() => {
        if (showRecords == false) {
            onChange({
                has_insurance_losses: false,
                insurance_losses_attributes: insuranceLosses.map((il) => {
                    return { ...il, _destroy: true };
                }),
            });
        }
        else if (showRecords && insuranceLosses.length > 0) {
            onChange({ has_insurance_losses: true });
        }
        else if (showRecords && insuranceLosses.length === 0) {
            onChange({
                has_insurance_losses: true,
                insurance_losses_attributes: [buildNewRecord()],
            });
        }
    }, [showRecords]);
    return (React.createElement("fieldset", null,
        React.createElement("h2", { id: "insurance-losses" }, "Insurance Losses"),
        React.createElement(YesNoInput, { name: "insurance_losses_show_records", label: "Have there been any General Liability or Accident Medical insurance losses for this event in the last 5 years?", value: showRecords, onChange: (v) => setShowRecords(v) }),
        showRecords && (React.createElement(React.Fragment, null,
            insuranceLosses
                .filter((r) => !r._destroy)
                .map((insuranceLoss) => {
                const lossKey = insuranceLoss.id || insuranceLoss.key || '';
                return (React.createElement("div", { key: lossKey },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 4 },
                            React.createElement(SelectInput, { label: "Year", id: `insurance_loss_${lossKey}_year`, required: true, value: insuranceLoss.year
                                    ? insuranceLoss.year.toString()
                                    : null, onChange: (v) => onUpdate(insuranceLoss, 'year', v), options: lastFiveYears })),
                        React.createElement(Grid.Column, { width: 4 },
                            React.createElement(TextInput, { label: "Type of Loss", id: `insurance_loss_${lossKey}_type_of_loss`, required: true, value: insuranceLoss.type_of_loss, onChange: (v) => onUpdate(insuranceLoss, 'type_of_loss', v) })),
                        React.createElement(Grid.Column, { width: 4 },
                            React.createElement(NumberInput, { label: "Amount", id: `insurance_loss_${lossKey}_amount`, required: true, value: insuranceLoss.amount, onChange: (v) => onUpdate(insuranceLoss, 'amount', v) }))),
                    React.createElement(Button, { testId: `remove-loss-${lossKey}`, className: "button--small button--warning", type: "button", onClick: () => onRemove(insuranceLoss) }, "Remove Insurance Loss")));
            }),
            React.createElement(Button, { onClick: onAdd },
                insuranceLosses.length > 0 ? 'Add Another' : 'Add',
                " Insurance Loss"),
            React.createElement("div", { className: "input__error" }, errors
                .filter((e) => e.field.includes('organization_insurance_losses'))
                .map((e) => (React.createElement("p", { key: e.field },
                e.label,
                " - ",
                e.messages.join('; ')))))))));
};
